import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ProblemService } from '../problem.service';
import { MultiChoiceComponent } from '../multi-choice/multi-choice.component';
import { ExerciseService } from '../exercise.service';
import { ProblemInfo } from '../ProblemInfo';
import { ParamsService } from '../../../../../shared/params.service';
import { UtilitiesService } from '../../../../../shared/utilities.service';
import { Subscription } from 'rxjs';
import { ContentViewerComponent } from '../../../../../shared/content-viewer/content-viewer.component';
import { SpinnerComponent } from '../../../../../shared/spinner/spinner.component';


@Component({
    selector: 'app-problem-multiple-choice-container-orig',
    templateUrl: './problem-multiple-choice-container.component.html',
    styleUrls: ['./problem-multiple-choice-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ContentViewerComponent, MultiChoiceComponent, SpinnerComponent]
})
export class ProblemMultipleChoiceContainerComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  lessonId: number;
  exerciseId: number;
  @Input() title: string;
  @Input() isStrategyProblem: boolean;
  @Input() isPersistences: boolean;
  @Input() correctTitle: string;
  @Input() incorrectTitle: string;
  @Input() discardedOptions: string[];
  @Output() onNext: EventEmitter<boolean> = new EventEmitter();
  @Output() onRestartTimer: EventEmitter<boolean> = new EventEmitter();
  @Output() onStopTimer: EventEmitter<boolean> = new EventEmitter();

  readyToContinue = false;
  isLoading = false;
  problemInfo: ProblemInfo;

  @ViewChild(MultiChoiceComponent)
  private multiChoiceComponent: MultiChoiceComponent<string>;


  constructor(private problemService: ProblemService,
              private exerciseService: ExerciseService,
              private paramsService: ParamsService,
              private activatedRoute: ActivatedRoute,
              public utilitiesService: UtilitiesService) {
  }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.params.subscribe((params) => {
      if (params['exerciseId']) {
        this.exerciseId = +params['exerciseId'];
      }
      if (params['lessonId']) {
        this.lessonId = +params['lessonId'];
      }
      this.subscriptions.add(this.problemService.getCurrentProblemInfo(this.lessonId, this.exerciseId).subscribe(
        problemInfo => {
          this.problemInfo = problemInfo;
          if (!this.isStrategyProblem) {
            this.problemService.startProblemTimer(problemInfo.problem.id);
          }
        }
      ));
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onUserSelection(option: string) {
    this.isLoading = true;
    this.onStopTimer.emit(true);
    const solutionId = this.problemInfo.problem.solutionId;
    const problemCase = this.paramsService.getRouteDataById('problemCase', this.activatedRoute.snapshot).toString();
    this.subscriptions.add(this.problemService.saveUserAnswer(this.exerciseId, solutionId, option, this.isPersistences).subscribe(
      result => {
        if (problemCase !== 'strategyProblem') {
          this.exerciseService.updateProblemOfExercise();
        }
        this.multiChoiceComponent.setRightOption(result);
        this.isLoading = false;
      }
    ));
  }

  handleReadyToContinue() {
    this.readyToContinue = true;
  }

  loadNextProblem() {
    this.subscriptions.add(this.problemService.getCurrentProblemInfo(this.lessonId, this.exerciseId).subscribe(
      problemInfo => {
        this.problemInfo = problemInfo;
        this.readyToContinue = false;
        this.discardedOptions = null;
        this.multiChoiceComponent.reset();
        if (!this.isStrategyProblem) {
          this.problemService.startProblemTimer(problemInfo.problem.id);
          this.onRestartTimer.emit(true);
        }
      }
    ));
  }

  handleNext() {
    this.onNext.emit(true);
  }
}
